<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          <a-input
            placeholder="角色名称"
            v-model:value="searchForm.roleName"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item></a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title="角色列表"
      style="margin-top: 20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <template v-slot:extra>
        <a-button @click="toAdd" type="primary">添加</a-button>
      </template>

      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :row-key="(r) => r.roleId"
        :loading="loading"
        style="overflow-y:scroll"
      >
        <template v-slot:switch="{ text, record, index }">
          <a-switch
            :defaultChecked="record.status == 0 ? true : false"
            @change="onChange(record, index)"
          />
        </template>

        <template v-slot:button="{ text, record }">
          <a-button type="primary" @click="edit(record)"> 编辑</a-button>
        </template>
      </a-table>
    </a-card>

    <df-pagination :model="pageObj"></df-pagination>

    <a-modal
      v-model:visible="modalVisible"
      title="添加角色"
      @ok="handleOk"
      :destroyOnClose="true"
    >
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        :ref="setsubmitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="角色名称" name="roleName" v-if="!isedit">
          <a-input
            v-model:value="submitForm.roleName"
            placeholder="角色名称"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="权限字符" name="roleKey">
          <a-input
            v-model:value="submitForm.roleKey"
            placeholder="权限字符"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="排序" name="roleSort">
          <a-input-number
            v-model:value="submitForm.roleSort"
            placeholder="排序"
            :min="1"
            :max="100"
            style="width: 282px"
          />
        </a-form-item>
        <a-form-item label="状态" name="main">
          <a-radio-group
            v-model:value="submitForm.status"
            button-style="solid"
            default-value="0"
          >
            <a-radio-button value="0"> 开启</a-radio-button>
            <a-radio-button value="1"> 关闭</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="菜单权限" name="menuIds">
          <df-selectMenuTree
            :model="submitForm"
            v-model:value="submitForm.menuIds"
            @setValue="setValue"
            style="width: 282px"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import roleApi from "@axios/sys/role";
import staticof from "@assets/static";
import { ref, reactive, provide } from "vue";
import { useRouter } from "vue-router";
import { notification } from "ant-design-vue";
import { SmileOutlined } from "@ant-design/icons-vue";
import moment from "moment";

export default {
  name: "roleIndex",
  components: {},
  setup() {
    let submitFormref = "";
    const setsubmitForm = (el) => {
      submitFormref = el;
    };

    const router = useRouter();
    let submitForm = reactive({
      roleName: "",
      roleKey: "",
      roleSort: "",
      status: "",
      menuIds: [],
    });
    const rules = {
      roleName: [
        { required: true, message: "请输入角色名称", trigger: "blur" },
      ],
      roleKey: [{ required: true, message: "请输入权限字符", trigger: "blur" }],
      // roleSort: [{ required: true, message: "请输入排序", trigger: "blur" }],
    };

    let loading = ref(false);
    let modalVisible = ref(false);
    let searchForm = reactive({
      roleName: "",
    });
    let searchParams = reactive({
      roleName: "",
    });

    let names = ref("");

    let list = ref([]);

    const columns = [
      {
        title: "角色名称",
        dataIndex: "roleName",
        width: 200,
        align: "center",
      },
      {
        title: "权限字符",
        dataIndex: "roleKey",
        width: 200,
        align: "center",
      },
      {
        title: "角色排序",
        dataIndex: "roleSort",
        width: 200,
        align: "center",
      },
      {
        title: "开关",
        dataIndex: "status",
        width: 100,
        align: "center",
        slots: { customRender: "switch" },
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 200,
        align: "center",
      },
      {
        title: "操作",
        dataIndex: "createTime",
        width: 100,
        align: "center",
        slots: { customRender: "button" },
      },
    ];

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const stateValue = ["关闭", "开启"];

    const searchAction = () => {
      searchParams.roleName = searchForm.roleName;
      console.log(searchParams);
      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };
    //查询列表
    const getList = () => {
      loading.value = true;
      let params = {
        roleName: searchParams.roleName ? searchParams.roleName : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };
      roleApi.roleListPage(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };

    const reset = () => {
      searchForm.roleName = "";
      searchAction();
    };

    const toAdd = () => {
      modalVisible.value = true;
      isedit.value = false;
      submitForm.roleName = "";
      submitForm.status = "0";
      submitForm.roleKey = "";
      submitForm.roleSort = "";
      submitForm.menuIds = [];
    };
    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const handleOk = () => {
      submitFormref
        .validate()
        .then(() => {
          //添加账号
          if (isedit.value) {
            console.log(JSON.stringify(submitForm.menuIds.val));
            let meunIdNumberArray = [];
            submitForm.menuIds.val.forEach(function(item, index) {
              meunIdNumberArray.push(Number(item));
            });

            let params = {
              roleId: editid,
              roleName: submitForm.roleName,
              roleKey: submitForm.roleKey,
              roleSort: submitForm.roleSort,
              menuIds: meunIdNumberArray,
            };
            roleApi.roleEdit(params).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "编辑成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          } else {
            console.log(JSON.stringify(submitForm.menuIds.val));
            let meunIdNumberArray = [];
            submitForm.menuIds.val.forEach(function(item, index) {
              meunIdNumberArray.push(Number(item));
            });

            let params = {
              roleName: submitForm.roleName,
              roleKey: submitForm.roleKey,
              roleSort: submitForm.roleSort,
              status: submitForm.status,
              menuIds: meunIdNumberArray,
            };
            roleApi.addRole(params).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "添加成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    //部门值
    const setValue = (val) => {
      submitForm.menuIds = val;
    };

    let isedit = ref(false);
    let editid = "";
    const edit = (row) => {
      if (submitFormref) submitFormref.resetFields();
      editid = row.roleId;
      isedit.value = true;
      modalVisible.value = true;
      submitForm.roleName = row.roleName;
      submitForm.roleKey = row.roleKey;
      (submitForm.roleSort = row.roleSort),
        (submitForm.status = row.status),
        (submitForm.menuIds = row.menuIds);
    };

    const onChange = (row, index) => {
      roleApi
        .switchState(row.roleId)
        .then(() => {
          notification.open({
            message: "修改成功",
            icon: <SmileOutlined style="color: #108ee9" />,
          });
          getList();
        })
        .catch(() => {
          notification.open({
            message: "修改失败",
            icon: <SmileOutlined style="color: #108ee9" />,
          });
          getList();
        });
    };
    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);
    getList();

    return {
      onChange,
      isedit,
      edit,
      names,
      staticof,
      loading,
      searchForm,
      searchParams,
      list,
      columns,
      pageObj,
      stateValue,
      searchAction,
      reset,
      toAdd,
      modalVisible,
      moment,
      disabledDate(current) {
        return current && current < moment().endOf("day");
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rules,
      submitForm,
      handleOk,
      setsubmitForm,
      setValue,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
</style>
